import {Field} from "formik"
import React from "react"

type Props = {
	name: string
	placeholder?: string
	icon: React.ReactNode
	loading?:boolean
}

const InputWithIcon = ({name, placeholder, icon, loading = false}: Props) => {
	return (
		<Field id={name}
			name={name}>
			{({
				field
			}) => (
				<div className={"position-relative bg-white border rounded"} >
					<div className="col-9">
						<input type="text"
							{...field}
							placeholder={placeholder}
							className={"border-0 ps-3 rounded py-2 d-block w-100 discount-code-input overflow-hidden"}/>
					</div>
					<button type="submit"
						className={"btn position-absolute top-0 end-0 bottom-0"}
						style={{
							width: 48
						}}>
						{loading ? <span className="spinner-border spinner-border-sm text-primary"
							role="status"
							aria-hidden="true"/> : icon}
					</button>
				</div>
			)}
		</Field>

	)
}

export default InputWithIcon
